import { defineComponent as _defineComponent } from 'vue'

// import Notifications, { SlotProps } from 'vue-notifications/Notifications.vue';
import Notifications from 'vue-notifications/Notifications.vue';

import Icon from '@components/Icon.vue';

import { faTimes } from '@icons/solid/faTimes';

declare module 'vue/types/vue' {
  export interface Vue {
    NotificationsRoot: ComponentWithProps;
  }
}

const __default__ = { name: 'NotificationsRoot' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

return { __sfc: true,Notifications, Icon, faTimes }
}

})